import styled from 'styled-components';
import { containerPaddingM } from 'common/styles/variables';
import { HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS } from 'common/components/TouchpointEditor/components/TouchpointContainer';

export const LogoStyles = styled.img.attrs((props) => ({
    style: {
        width: `${props.$width}px`,
    },
}))`
    ${HIGHLIGHT_AND_CONTENT_EDITING_BEHAVIOR_CSS}
`;

export const RangeContainer = styled.div`
    display: grid;
    grid-template-columns: 3fr 1fr;
    align-items: center;
    column-gap: ${containerPaddingM};
`;
